"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineEditorNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const helpers_1 = require("../../../utils/helpers");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'LINE-EDITOR';
class LineEditorNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            try {
                const existingLine = (0, helpers_1.getLineFromString)(params.existingLine);
                const newStartPoint = (0, helpers_1.getPointFromString)(params.newStartPoint);
                const newEndPoint = (0, helpers_1.getPointFromString)(params.newEndPoint);
                const newLine = existingLine;
                if (newStartPoint) {
                    // replace existing start point with new one
                    newLine.coordinates[0] = newStartPoint.coordinates;
                }
                if (newEndPoint) {
                    // replace existing start point with new one
                    newLine.coordinates[newLine.coordinates.length - 1] = newEndPoint.coordinates;
                }
                // We have to ts-ignore here, because we can't add GeoJSON objects to our list of supportedDataMap types
                //eslint-disable-next-line
                //@ts-ignore
                return { updatedLine: newLine };
            }
            catch (e) { }
            return null;
        };
        // We have to redefine our inputparams to handle geoJson objects
        this._interfaceDefinition = {
            definitions: Object.assign(Object.assign({}, Schema.definitions), { InputParams: {
                    type: 'object',
                    properties: {
                        existingLine: {
                            anyOf: [
                                {
                                    $ref: '/Geography/GeoJSON',
                                },
                                {
                                    description: 'Existing Line',
                                    type: 'string',
                                    title: 'existingLine',
                                },
                            ],
                        },
                        newStartPoint: {
                            anyOf: [
                                {
                                    $ref: '/Geography/GeoJSON',
                                },
                                {
                                    description: 'New Starting Point',
                                    type: 'string',
                                    title: 'newStartPoint',
                                },
                            ],
                        },
                        newEndPoint: {
                            anyOf: [
                                {
                                    $ref: '/Geography/GeoJSON',
                                },
                                {
                                    description: 'New Ending Point',
                                    type: 'string',
                                    title: 'newEndPoint',
                                },
                            ],
                        },
                    },
                    required: ['source'],
                } }),
        };
    }
}
exports.LineEditorNode = LineEditorNode;
LineEditorNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Line Editor',
    isIdempotent: true,
    primaryCategory: 'Geography',
};
//# sourceMappingURL=LineEditor.js.map